import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; // Add this import
import GardenLayout from './InGroundGardenDesigner';
import GardenStyle from './GardenStyle';
import GardenStyleDropdown from './GardenStyleDropdown';
import MainPageTutorialFirst from "./tutorialComponents/MainPageTutorialFirst";
import MainPageTutorialSecond from "./tutorialComponents/MainPageTutorialSecond";
import HeroCard from './HeroCard';
import OpeningOption from "./OpeningOption";
import SlideInPanel from './SlideInPanel';
import TutorialPopup from "./tutorialComponents/TutorialPopup";
import StatsSection from './StatsSection';
import MainPageFooter from './MainPageFooter';
import SignInPage from './landingPageComponents/SignInPage';
import './GardenStyling.css';
import '../css/GardenLayoutMainPageStyling.css';

import garden6 from '../images/plantBackground6.jpeg';

import { supabase } from './lib/supabaseClient';

const GardenLayoutMainPage = () => {
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [showLayout, setShowLayout] = useState(false);
    const [selectedStyle, setSelectedStyle] = useState(null);

    // New state for showing garden styles
    const [showGardenStyles, setShowGardenStyles] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    // Background transition states
    const [bgIndex1, setBgIndex1] = useState(0);
    const [bgIndex2, setBgIndex2] = useState(1);
    const [activeBg, setActiveBg] = useState(1);

    // Parallax effect state
    const [scrollPosition, setScrollPosition] = useState(0);
    const parallaxRef = useRef(null);

    // List of background images
    const backgroundImages = [`url(${garden6})`];

    // Slide in panel
    const [panelOpen, setPanelOpen] = useState(false);

    // animating the opening options
    const [showOpeningOptions, setShowOpeningOptions] = useState(true);
    const [isReversing, setIsReversing] = useState(false);
    const [isReady, setIsReady] = useState(false);

    // Use the useAuth hook instead of local state
    const { user, isLoggedIn, refresh } = useAuth();

    // Login screen state
    const [showLogInScreen, setshowLogInScreen] = useState(false);
    const [signInContext, setSignInContext] = useState(null);

    const navigate = useNavigate();

    // Remove the local auth state management and use the hook instead
    // const [isLoggedIn, setIsLoggedIn] = useState(false); // Remove this line

    // Background transition effect (COMMENTED OUT FOR NOW BUT STILL WORKS!)
    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         console.log('Starting background transition');
    //
    //         if (activeBg === 1) {
    //             const nextIndex = (bgIndex1 + 1) % backgroundImages.length;
    //             setBgIndex2(nextIndex);
    //             setActiveBg(2);
    //         } else {
    //             const nextIndex = (bgIndex2 + 1) % backgroundImages.length;
    //             setBgIndex1(nextIndex);
    //             setActiveBg(1);
    //         }
    //     }, 30000);
    //
    //     return () => clearInterval(intervalId);
    // }, [activeBg, bgIndex1, bgIndex2, backgroundImages.length]);

    useEffect(() => {
        const fetchData = async () => {
            const { data, error } = await supabase.from('users').select('*');
            console.log(
                "%c🌱 If you are reading this, give me a job!\n📬 Or bang the email if you wanna talk plants:\nplantedgardendesigner@gmail.com",
                "color: #4CAF50; font-size: 16px; font-weight: bold; padding: 5px; border-radius: 5px"
            );
        };

        fetchData();
    }, []);

    // Parallax scrolling effect
    useEffect(() => {
        const handleScroll = () => {
            const position = window.pageYOffset;
            setScrollPosition(position);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const openingOptions = [
        "Garden Designer",
        "Your Gardens",
        "Plant Finder",
        "Community Gardens"
    ]

    const gardenStyles = [
        "In Ground Garden",
        "Raised Bed Garden",
        "Container Garden",
        "Indoor Garden",
        "Vertical Garden",
        "Hydroponic Garden"
    ];

    const gardenRoutes = {
        "In Ground Garden": "/in-ground-layout-page",
        "Raised Bed Garden": "/raised-bed-garden",
        "Container Garden": "/container-garden",
        "Indoor Garden": "/indoor-garden",
        "Vertical Garden": "/vertical-garden",
        "Hydroponic Garden": "/hydroponic-garden"
    };

    const handleOpeningOptionSelect = (option) => {
        if (option === "Garden Designer") {
            if(1 === 0) { // Now uses the hook's isLoggedIn (used to be !isLoggedIn, but now we allow guests to create not save gardens)
                handleLoginClick("2");
            } else {

                navigate("/in-ground-layout-page");
                // to show other garden options but theres only one designer for rn

                // setIsAnimating(true);
                // setShowGardenStyles(true);
                // // Step 1: animate out opening options
                // setTimeout(() => {
                //     // Step 2: hide opening options and show garden styles
                //     setShowOpeningOptions(false);
                //     // setShowGardenStyles(true);
                //
                //     // Step 3: stop animating
                //     setTimeout(() => {
                //         setIsAnimating(false);
                //     }, 500);
                // }, 500); // Match the slide-out animation duration
            }
        } else if (option === "Your Gardens") {
            navigate("/dashboard");
        } else if (option === "Plant Finder") {
            navigate("/plant-finder");
        }
    };

    const handleBackToOpeningOptions = () => {
        setIsReversing(true);       // Mark this as reverse animation
        setIsAnimating(true);       // Trigger animations
        setShowOpeningOptions(true); // Show opening options immediately to start slide-in

        // After the animation duration, clean up states
        setTimeout(() => {
            setShowGardenStyles(false);  // Hide garden styles after animation completes
            setIsAnimating(false);
            setIsReversing(false);       // Reset
        }, 500); // Match the CSS animation duration
    };

    const clickHandler = () => {
        if (width && height) {
            setShowLayout(true);
        } else {
            alert('Please enter valid width and height.');
        }
    };

    const heroRef = useRef(null);

    const scrollToBottomOfHero = () => {
        if(!isLoggedIn) { // Now uses the hook's isLoggedIn
            handleLoginClick("1");
        } else if (heroRef.current) {
            const bottom = heroRef.current.offsetTop + heroRef.current.offsetHeight;
            window.scrollTo({
                top: bottom,
                behavior: 'smooth',
            });
        }
    };

    const handleLoginClick = (directContext = null) => {
        if (!isLoggedIn) { // Now uses the hook's isLoggedIn
            setSignInContext(directContext);
            setshowLogInScreen(true);
        }
    };

    const exitLoginAsGuest = () => {
        setshowLogInScreen(false);
        // If you want to set a guest mode, you might need to update your useAuth hook
        // For now, just close the screen
    }

    const exitLoginAsUser = (userData) => {
        setshowLogInScreen(false);
        // Force a re-render or trigger auth state update if needed
        // If your useAuth hook has a method to update user data, call it here
        refresh();
    }

    if (showLayout) {
        return <GardenLayout width={parseInt(width)} height={parseInt(height)} onBack={() => setShowLayout(false)} />;
    }

    // Calculate parallax background position - slower movement than normal scroll
    const backgroundY = scrollPosition * 0.3; // Adjust this multiplier to control parallax intensity

    return (
        <>
            {showLogInScreen && (
                <div className="login-overlay">
                    <SignInPage
                        onLoginSuccess={() => exitLoginAsUser()}
                        onClose={() => setshowLogInScreen(false)}
                        signInType={signInContext}
                        onCloseAsGuest={() => exitLoginAsGuest()}/>
                </div>
            )}
            {selectedStyle && (
                <TutorialPopup
                    screens={[
                        <MainPageTutorialFirst />,
                        <MainPageTutorialSecond />
                    ]}
                    isOpen={panelOpen}
                    onClose={() => {
                        setPanelOpen(false);
                        setSelectedStyle(null);
                    }}
                    onFinish={() => navigate(gardenRoutes[selectedStyle])}
                />
            )}
            <div className="parallax-container" ref={parallaxRef}>
                {/* Background layers with parallax effect */}
                <div
                    className="background-container"
                    style={{
                        backgroundImage: backgroundImages[bgIndex1],
                        opacity: activeBg === 1 ? 1 : 0,
                        transition: 'opacity 1s ease-in-out',
                        position: 'fixed', // Fixed position for parallax
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundPosition: `center ${-backgroundY}px`, // Move background at slower rate
                        backgroundSize: 'cover',
                        zIndex: 0
                    }}
                />

                <div
                    className="background-container"
                    style={{
                        backgroundImage: backgroundImages[bgIndex2],
                        opacity: activeBg === 2 ? 1 : 0,
                        transition: 'opacity 1s ease-in-out',
                        position: 'fixed', // Fixed position for parallax
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundPosition: `center ${-backgroundY}px`, // Move background at slower rate
                        backgroundSize: 'cover',
                        zIndex: 0
                    }}
                />

                {/* Content - scrolls normally */}
                <div className="content-container" style={{position: 'relative', zIndex: 1}}>
                    <div ref={heroRef}>
                        <HeroCard onButtonClick={scrollToBottomOfHero} isLoggedIn={isLoggedIn} user={user}/>
                    </div>
                    <div className="body-container">
                        <div className="form-container">
                            <div className="form-container-header">
                                {showGardenStyles && (
                                    <button
                                        onClick={handleBackToOpeningOptions}
                                        className="back-to-options-button"
                                        disabled={isAnimating}
                                    >
                                        &#8617;
                                    </button>
                                )}
                                    <h1 className="form-container-title">Your Complete Garden Toolkit</h1>
                            </div>

                            <div className={"options-panel-wrapper"}>
                                <div className="form-container-content">
                                    {showOpeningOptions && (
                                        <div
                                            className={`opening-options-container ${
                                                showOpeningOptions && !isAnimating ? 'visible' : ''
                                            } ${isAnimating && isReversing ? 'slide-in' : ''}
                                        ${isAnimating && !isReversing ? 'animate-out' : ''}`}>

                                            {openingOptions.map((option) => (
                                                <OpeningOption
                                                    key={option}
                                                    gardenType={option}
                                                    onSelect={handleOpeningOptionSelect}
                                                    isSelected={false} // Reset selection when going back
                                                />
                                            ))}
                                        </div>
                                    )}

                                    <div className={`garden-style-choices ${showGardenStyles ? 'visible' : ''}
                            ${isAnimating && !isReversing ? 'slide-in' : ''}
                            ${isAnimating && isReversing ? 'slide-out' : ''}
                            ${isReady ? 'ready' : ''}`}>
                                        {gardenStyles.map((style) => (
                                            <GardenStyle
                                                key={style}
                                                gardenType={style}
                                                onSelect={(style) => {
                                                    setSelectedStyle(style);
                                                    setPanelOpen(true);
                                                }}
                                                isSelected={selectedStyle === style}
                                                className="garden-style-card"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <StatsSection/>
                    <MainPageFooter/>
                    {/* Add extra content to enable scrolling for testing parallax */}
                    {/*<div style={{ height: '25vh' }}></div>*/}
                </div>
            </div>
        </>
    );
};

export default GardenLayoutMainPage;